<template>
  <div class="style-editor">
    <div class="" style="display: none">
      {{search}}
    </div>
    <div ref="editor" style="height: 100vh"></div>
  </div>
</template>
<script>

import Vue from 'vue'
//
// var CodeMirror = require('codemirror')
//
// require('codemirror/mode/css/css')
// require('codemirror/addon/hint/show-hint.css')
// require('codemirror/addon/edit/matchbrackets.js')
// require('codemirror/addon/edit/closebrackets.js')
// require('codemirror/addon/hint/show-hint.js')
// require('codemirror/addon/lint/lint.js')
// window.CSSLint = require('codemirror/addon/lint/css-lint.js')
//
// var cssHint = require('codemirror/addon/hint/css-hint.js')
//
// var emmetCodeMirror = require('emmet-codemirror')

export default {
  name: "style-editor",
  props: ["code", "search", "onChange"],
  components: {

  },
  data: () => ({
    cm: null,
    editorOption: {
      extraKeys: {"Ctrl-Space": "autocomplete", "Ctrl-.": "fontinject", "Ctrl-,": "findCSS"},
      hintWords: ["@green", "@red"],
      indentWithTabs: true,
      // matchBrackets: true,
      mode: "css",
      gutters: ["CodeMirror-lint-markers"],
      mode: "css",
      lineNumbers: true,
      styleActiveLine: true,
      tabSize: 2,
      theme: 'duotone-light',
      value: "dsadsa"
    }
  }),
  mounted: function () {
    setTimeout(() => {
      this.cm = CodeMirror(this.$refs.editor, this.editorOption);
      this.cm.on("change", this.handleCodeChange);

      var orig = CodeMirror.hint.css;

      CodeMirror.registerHelper("hint","css",function(cm,options){
        var cur=cm.getCursor(),token=cm.getTokenAt(cur);
        return {
          list:[
            {
              text: "var(--c-text)",
              displayText: "Text Color"
            },
            {
              text: "var(--c-accent)",
              displayText: "Accent Color"
            }
          ],
          from: CodeMirror.Pos(cur.line, token.start + 1),
          to: CodeMirror.Pos(cur.line, token.end)
        }
      });



      CodeMirror.commands.autocomplete = function(cm) {
        cm.showHint({hint: CodeMirror.hint.css});
      }

      CodeMirror.commands.fontinject = function(cm) {
        var sel = cm.getDoc().getSelection()
        cm.getDoc().setSelection({line: 0, ch: 0})
        cm.execCommand("newlineAndIndent")
        cm.execCommand("newlineAndIndent")
        cm.getDoc().replaceRange("@import url('https://fonts.googleapis.com/css?family=" + sel + "');", {line:0,ch:0})
      }

      var editor = this.cm;

      this.cm.on("cursorActivity",function(cm){
        var selection=cm.getSelection();
        if(selection.indexOf("#") != -1){
          editor.execCommand("autocomplete");
        }
      })

      emmetCodeMirror(this.cm);

      this.cm.getDoc().setValue(this.code)

    }, 10)

    setTimeout(() => {
      console.log(this.cm.getSearchCursor('https'))
    }, 2000)

  },
  updated: function () {
    var cursor = this.cm.getSearchCursor("\n" + this.search.toLowerCase() + " ")

    if (cursor.find()) {

      this.cm.setSelection({line: cursor.from().line + 2, ch: this.cm.getLine(cursor.from().line+2).length});
      this.cm.scrollIntoView({from: cursor.from(), to: cursor.to()}, 400);

      setTimeout(() => {
        this.cm.focus()
      }, 0)
    }
  },
  methods: {
    handleCodeChange: function (editor) {
      this.onChange(editor.doc.getValue())
    }
  }
}
</script>
<style lang="scss">
.style-editor {
  height: 100vh;
  font-size: 20px;
}

.CodeMirror {
  height: 100%;
  background: #222;
}

.CodeMirror-linebackground {
  background: rgba(0, 0, 0, 0.1);
}
</style>
